import React from "react";
import { NavLink } from "react-router-dom";

import { StyledFooterBlockItem, StyledFooterBlockItemList, StyledFooterBlockItemTitle } from "./styledFooter";

const FooterIntegration = () => {
  return (
    <StyledFooterBlockItem>
      <StyledFooterBlockItemTitle>
        Integration
      </StyledFooterBlockItemTitle>
      <StyledFooterBlockItemList>
        <li>
          <NavLink to="/manual-connect-web">
            Application
          </NavLink>
        </li>
        <li>
          <NavLink to="/manual-connect-viber">
            Viber
          </NavLink>
        </li>
        <li>
          <NavLink to="/manual-connect-telegram">
            Telegram
          </NavLink>
        </li>
        <li>
          <NavLink to="/whatsApp">
            WhatsApp
          </NavLink>
        </li>
      </StyledFooterBlockItemList>
    </StyledFooterBlockItem>
  );
};

export default FooterIntegration;